import clsx from 'clsx';
import React, { useState } from 'react';
import { useMutationObserver } from '../../hooks/use-mutation-observer';
import { findUpUntil } from '../../utils/dom';
export var useVisualContext = function (elementRef) {
    var contextMatch = /awsui-context-([\w-]+)/;
    var _a = useState(''), value = _a[0], setValue = _a[1];
    useMutationObserver(elementRef, function (node) {
        var contextParent = findUpUntil(node, function (node) { return !!node.className.match(contextMatch); });
        setValue(contextParent ? contextParent.className.match(contextMatch)[1] : '');
    });
    return value;
};
export default function VisualContext(_a) {
    var contextName = _a.contextName, className = _a.className, children = _a.children;
    return React.createElement("div", { className: clsx("awsui-context-" + contextName, className) }, children);
}
